import {
	ExtensionContextBase,
	ExtensionContextType,
	ExtensionsRegistry,
} from '@elyx-code/project-logic-tree';
import { EditorService } from './EditorService';

/*
  Editor UI specific context exposed to extensions

  The editor UI context is a reduced subset API of the Editor UI class which can be used by extensions
  This is for security reasons.
  We don't want the extensions to have direct access to the Editor UI class or access any API and internal state that they want.
  Through this context, extensions can only access the project state in a controlled manner.

  In the future, we can check against a whitelisted manifest of allowed methods and properties
  for each extension that this context is passed to.
*/
export interface IEditorUIContext
	extends ExtensionContextBase<ExtensionContextType.EditorGUI> {}

export class EditorUIContext
	extends ExtensionContextBase<ExtensionContextType.EditorGUI>
	implements IEditorUIContext
{
	constructor(
		extensionsRegistry: ExtensionsRegistry,
		private readonly _editor: EditorService
	) {
		super(extensionsRegistry, ExtensionContextType.EditorGUI);
	}
}

export function toEditorUIContext(
	extensionsRegistry: ExtensionsRegistry,
	editor: EditorService
): EditorUIContext {
	if (editor instanceof EditorUIContext) {
		return editor;
	}

	return new EditorUIContext(extensionsRegistry, editor);
}
